import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";
import { Link } from "react-router-dom";
import { ShieldCheck, Lock, Clock3, BadgeCheck } from "lucide-react";

const WHEEL = "https://images.pexels.com/photos/7594180/pexels-photo-7594180.jpeg?auto=compress&cs=tinysrgb&w=1200";
const BG = "https://images.pexels.com/photos/7594343/pexels-photo-7594343.jpeg?auto=compress&cs=tinysrgb&w=1920";

const STATS = [["15 ₼", "Minimum depozit"], ["24/7", "Canlı dəstək"], ["45+", "Kazino oyunu"], ["RTP 97%", "Ədalətli oyun"]];
const TRUST = [[ShieldCheck, "Lisenziyalı operator"], [Lock, "SSL ilə qorunan ödənişlər"], [Clock3, "Sürətli çıxarış"], [BadgeCheck, "18+ məsuliyyətli oyun"]];

const Chip = ({ className, color, delay }) => (
  <div className={`absolute float-y ${className}`} style={{ animationDelay: `${delay}s` }}>
    <div className="w-16 h-16 rounded-full border-[6px] border-dashed border-white/80 shadow-2xl flex items-center justify-center font-display font-black text-sm text-white" style={{ background: color }}>JP</div>
  </div>
);

export const Hero3D = () => {
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rx = useSpring(useTransform(my, [-0.5, 0.5], [10, -10]), { stiffness: 80, damping: 15 });
  const ry = useSpring(useTransform(mx, [-0.5, 0.5], [-14, 14]), { stiffness: 80, damping: 15 });
  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width - 0.5);
    my.set((e.clientY - r.top) / r.height - 0.5);
  };

  return (
    <section onMouseMove={onMove} className="relative overflow-hidden" data-testid="hero-section">
      <img src={BG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-20" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#050505] via-[#050505]/90 to-[#050505]/60" />
      <div className="absolute -left-40 top-20 w-[520px] h-[520px] rounded-full bg-[#7B001C]/35 blur-[120px]" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-8 w-full grid lg:grid-cols-[1.15fr_1fr] gap-12 items-center pt-16 pb-12 min-h-[620px]">
        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} className="space-y-8">
          <span className="inline-flex items-center gap-2 border-l-2 border-[#D4AF37] pl-3 text-xs uppercase tracking-[0.3em] text-[#D4AF37]" data-testid="license-badge">
            Azərbaycanın onlayn kazinosu
          </span>
          <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[1.05]" data-testid="hero-title">
            Əsl kazino atmosferi.<br /><span className="gold-text">İndi ekranınızda.</span>
          </h1>
          <p className="text-zinc-400 text-base md:text-lg max-w-lg leading-relaxed">
            Rulet, slotlar, Aviator və canlı raundlar. Şəffaf qaydalar, qorunan hesab və kart və ya m10 ilə rahat ödəniş.
          </p>
          <div className="flex flex-wrap gap-4">
            <Link to="/register" className="btn-gold rounded-full px-8 py-4 font-display font-bold" data-testid="hero-cta-btn">Hesab yarat</Link>
            <Link to="/login" className="btn-ghost rounded-full px-8 py-4 font-semibold" data-testid="hero-login-btn">Hesabım var</Link>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-px bg-white/10 border border-white/10 rounded-2xl overflow-hidden max-w-2xl">
            {STATS.map(([a, b]) => (
              <div key={b} className="bg-[#0a0a0a] px-4 py-4"><p className="font-display font-bold text-xl gold-text">{a}</p><p className="text-[11px] uppercase tracking-[0.18em] text-zinc-500 mt-1">{b}</p></div>
            ))}
          </div>
        </motion.div>
        <div className="relative h-[460px] hidden sm:block" style={{ perspective: 1200 }}>
          <motion.div style={{ rotateX: rx, rotateY: ry, transformStyle: "preserve-3d" }} className="absolute inset-0 flex items-center justify-center">
            <div className="relative w-[420px] h-[420px] rounded-full p-3 bg-gradient-to-br from-[#D4AF37] via-[#7a5c12] to-[#D4AF37] shadow-[0_40px_120px_rgba(212,175,55,0.25)]" style={{ transform: "translateZ(40px)" }}>
              <img src={WHEEL} alt="Rulet" className="w-full h-full rounded-full object-cover animate-[spin_40s_linear_infinite]" />
            </div>
            <Chip className="top-4 left-4" color="#7B001C" delay={0} />
            <Chip className="bottom-8 right-2" color="#0b3d2e" delay={1.2} />
            <Chip className="top-16 right-6 scale-75" color="#111" delay={2.1} />
          </motion.div>
        </div>
      </div>
      <div className="relative border-t border-white/10 bg-black/50">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 py-5 grid grid-cols-2 md:grid-cols-4 gap-4" data-testid="trust-bar">
          {TRUST.map(([Icon, t]) => (
            <div key={t} className="flex items-center gap-3 text-sm text-zinc-300"><Icon size={18} className="text-[#D4AF37] shrink-0" />{t}</div>
          ))}
        </div>
      </div>
    </section>
  );
};
